import { MyVouchersService } from './../../../services/my-vouchers/my-vouchers.service';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToasterService, ToasterConfig } from 'angular5-toaster';
import { StorageService } from '../../../services/storage.service';
import { User } from '../../../models/user';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { distinctUntilChanged, debounceTime, switchMap, tap, catchError } from 'rxjs/operators';
import { concat } from 'rxjs/observable/concat';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import { Console } from 'console';

@Component({
  selector: 'app-uploadVouchers',
  templateUrl: './upload-vouchers.component.html',
  styleUrls: ['./upload-vouchers.scss'],
  providers: [ MyVouchersService ]
})
export class UploadVouchersComponent implements OnInit {
  @ViewChild('myTable') table: any;
  @Input() messages: any = {
    emptyMessage: '',
    totalMessage: '',
    selectedMessage: ''
  };
  // public user: User;
  rol;
  pais;
  selectedFile;
  file;
  files1;
  files2;
  mensajeVerificarDatos;
  sinDatos;
  archivoNoValido;
  rows = [];
  columns;
  flagExcel = false;
  btnEnviar = false;
  jsonExcel = null;
  closeResult: string;
  archivoZip;
  proveedorFilter;
  proveedores$: Observable<any>;
  proveedoresLoading = false;
  proveedorinput$ = new Subject<string>();
  busy: boolean = false;
  busyEnvio: boolean = false;
  cuentaProvSelected: Object;
  cuentas: Array<object>
  toastCamposVacios;
  provSinCuenta;
  modalRef: any;
  modalDetalle;
  textoRespuesta = "";
  detalleRespuesta = "";

  public tipo: boolean = false;
  public file1: string = "";
  public file2: string = "";

  public toasterconfig: ToasterConfig =
    new ToasterConfig({ timeout: 500 });
  constructor(
    private translate: TranslateService,
    private myVouchersService: MyVouchersService,
    private toasterService: ToasterService,
    private storageService: StorageService,
    private modalService: NgbModal,
    private _router: Router,
  ) {

    this.translate.get('texto.noHayInformacionLabel').subscribe(
      text => {
        this.messages.emptyMessage = text;
      });

    this.translate.get('texto.totalLabel').subscribe(
      text => {
        this.messages.totalMessage = text;
      });

     this.translate.get('texto.mensajeVerificarDatos').subscribe(
      text => {
      this.mensajeVerificarDatos = text;
    });

    this.translate.get('texto.sinDatos').subscribe(
      text => {
      this.sinDatos = text;
    });

    this.translate.get('texto.archivoNoValido').subscribe(
      text => {
      this.archivoNoValido = text;
    });

  }

  ngOnInit() {
    this.noBack();
    // this.user = this.storageService.getCurrentUser();
    // this.rol = this.user.rol.id;
    // this.pais = this.user.pais;
  }

  noBack() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  }
  
  clearInput(e, file) { 
    this.selectedFile = e.target.value = '';
    this.file = e.target.value = '';

    if (file == "excel") {
      this.files1 = [];
      this.file1 = "";
    } else {
      this.files2 = [];
      this.file2 = "";
    }
  }


  readExcelToJSON(e, files1, files2, modalDetalle) {
        let me = this;
        this.archivoZip = files2[0];
        this.selectedFile = files1[0];
        let tipo = this.selectedFile.name.split('.'); 

  
        if (tipo[1] == "csv" || tipo[1] == "xlsx") {


          var fileReader = new FileReader();
          // fileReader.readAsText(this.selectedFile)
          
          fileReader.onload = function(event) {
                var that = this;
                var data = (<FileReader>event.target).result;
                var workbook = XLSX.read(data, {
                    type: "binary"
                });
                workbook.SheetNames.forEach(sheet => {
                    let rowObject = XLSX.utils.sheet_to_json(
                        workbook.Sheets[sheet]
                    );
                    // console.log(rowObject)
               

              let csvDataNew = rowObject;

              if (csvDataNew.length > 0) {

                var json = {
                  "sociedad": "",
                  "proveedor": "",
                  "cuentaCargo": "",
                  "nombreOrd": "",
                  "nombreBeneficiario": "",
                  "cuentaAbono": "",
                  "producto": "",
                  "nombreArchivo": "",
                  "importe": "",
                  "intermediarioOrd": "",
                  "divisaOrd": "",
                  "documentoSap": "",
                  "comentario": "",
                  "fechaAplicacion": "",
                  "fechaOperacion": "",
                  "referencia": "",
                  "estatusPago": "",
                  "motivoRechazo": "",
                  "idComprobante": ""
               }
              //  console.log(csvDataNew)
               let keys:any = csvDataNew[1]; 
               let indexKeys;

                let indexCol1, indexCol2, indexCol3, indexCol4, indexCol5, indexCol6, indexCol7, indexCol8, indexCol9,
                    indexCol10, indexCol11, indexCol12, indexCol13, indexCol14, indexCol15, indexCol16, indexCol17, indexCol18, indexCol19;
                let sociedad = false, proveedor = false, cuenta_cargo = false, nombre_ord = false, nombre_ben = false,
                     cuenta_abono = false, producto = false, nombre_archivo = false, importe = false, intermediario_ord = false, divisa_ord = false,
                     doc_sap = false, comentario = false, fecha_apli = false, fecha_ope = false, refeferencia_sant = false, estatus_pago = false,
                     motivo_rechazo = false, id_comprobante = false;

                if (keys !== undefined) {
                  // console.log(keys)
                  // for (let k = 0; k < keys.length; k++) { 
                  
                  for (var key in keys) {
                    if (keys.hasOwnProperty(key)) {
                      var i = Object.keys(keys).indexOf(key); 
                     
                      if (keys[key].toUpperCase() === "CUENTA CARGO") {
                        indexCol1 = i;
                        cuenta_cargo = true;
                      }
                      if (keys[key].toUpperCase() === "NOMBRE ORD") {
                        indexCol2 = i;
                        nombre_ord = true;
                      }
                      if (keys[key].toUpperCase() === "NOMBRE BENEFICIARIO") {
                        indexCol3 = i;
                        nombre_ben = true;
                      }
                      if (keys[key].toUpperCase() === "CUENTA ABONO") {
                        indexCol4 = i;
                        cuenta_abono = true;
                      }
                      if (keys[key].toUpperCase() === "PRODUCTO") {
                        indexCol5 = i;
                        producto = true;
                      }
                      if (keys[key].toUpperCase() === "NOMBRE DE ARCHIVO") {
                        indexCol6 = i;
                        nombre_archivo = true;
                      }
                      if (keys[key].toUpperCase() === "IMPORTE") {
                        indexCol7 = i;
                        importe = true;
                      }
                      if (keys[key].toUpperCase() === "INTERMEDIARIO ORD") {
                        indexCol8 = i;
                        intermediario_ord = true;
                      }
                      if (keys[key].toUpperCase() === "DIVISA ORD") {
                        indexCol9 = i;
                        divisa_ord = true;
                      }
                      if (keys[key].toUpperCase() === "DOC SAP") {
                        indexCol10 = i;
                        doc_sap = true;
                      }
                      if (keys[key].toUpperCase() === "COMENTARIO 1" || keys[key].toUpperCase() === "COMENTARIO") {
                        indexCol11 = i;
                        comentario = true;
                      }
                      if (keys[key].toUpperCase() === "FECHA DE APLICACIÓN") {
                        indexCol12 = i;
                        fecha_apli = true;
                      }
                      if (keys[key].toUpperCase() === "FECHA DE LA OPERACIÓN") {
                        indexCol13 = i;
                        fecha_ope = true;
                      }
                      if (keys[key].toUpperCase() === "REFERENCIA SANTANDER") {
                        indexCol14 = i;
                        refeferencia_sant = true;
                      }
                      if (keys[key].toUpperCase() === "ESTATUS PAGO") {
                        indexCol15 = i;
                        estatus_pago = true;
                      }
                      if (keys[key].toUpperCase() === "MOTIVO DE RECHAZO") {
                        indexCol16 = i;
                        motivo_rechazo = true;
                      }
                      if (keys[key].toUpperCase() === "ID COMPROBANTE") {
                        indexCol17 = i;
                        id_comprobante = true;
                      }
                      if (keys[key].toUpperCase() === "SOCIEDAD") {
                        indexCol18 = i;
                        sociedad = true;
                      }
                      if (keys[key].toUpperCase() === "PROVEEDOR") {
                        indexCol19 = i;
                        proveedor = true;
                      }
                    }
                  }
  
  
                  
                  if (cuenta_cargo || sociedad || proveedor || nombre_ord || nombre_ben || nombre_archivo || importe) { 
  
                      var jsonArray = [];
  
                      let sociedadC = "", proveedorC = "", cuenta_cargoC = "", nombre_ordC = "", nombre_benC = "",
                      cuenta_abonoC = "", productoC = "", nombre_archivoC = "", importeC = "", intermediario_ordC = "", divisa_ordC = "",
                      doc_sapC = "", comentarioC = "", fecha_apliC = "", fecha_opeC = "", refeferencia_santC = "", estatus_pagoC = "",
                      motivo_rechazoC = "", id_comprobanteC = "";
                      
                      for (let i = 2; i < csvDataNew.length; i++) {
                        
                        let keys = Object.keys(csvDataNew[i]);
                        for (var j = 0; j < keys.length; j++){ 

                          
                             if (sociedad) {
                               sociedadC = csvDataNew[i][keys[indexCol18]];
                             } else {
                               sociedadC = "";
                             }
                             if (proveedor) {
                               proveedorC = csvDataNew[i][keys[indexCol19]];
                             } else {
                               proveedorC = "";
                             }
                             if (cuenta_cargo) {
                               cuenta_cargoC = csvDataNew[i][keys[indexCol1]];
                             } else {
                               cuenta_cargoC = "";
                             }
                             if (nombre_ord) {
                               nombre_ordC = csvDataNew[i][keys[indexCol2]];
                             } else {
                               nombre_ordC = "";
                             }
                             if (nombre_ben) {
                               nombre_benC = csvDataNew[i][keys[indexCol3]];
                             } else {
                               nombre_benC = "";
                             }
                             if (cuenta_abono) {
                               cuenta_abonoC = csvDataNew[i][keys[indexCol4]];
                             } else {
                               cuenta_abonoC = "";
                             }
                             if (producto) {
                               productoC = csvDataNew[i][keys[indexCol5]];
                             } else {
                               productoC = "";
                             }
                             if (nombre_archivo) {
                               nombre_archivoC = csvDataNew[i][keys[indexCol6]];
                             } else {
                               nombre_archivoC = "";
                             }
                             if (importe) {
                               importeC = csvDataNew[i][keys[indexCol7]];
                             } else {
                               importeC = "";
                             }
                             if (intermediario_ord) {
                               intermediario_ordC = csvDataNew[i][keys[indexCol8]];
                             } else {
                               intermediario_ordC = "";
                             }
                             if (divisa_ord) {
                               divisa_ordC = csvDataNew[i][keys[indexCol9]];
                             } else {
                               divisa_ordC = "";
                             }
                             if (doc_sap) {
                              doc_sapC = csvDataNew[i][keys[indexCol10]];
                            } else {
                              doc_sapC = "";
                            }
                            if (comentario) {
                              comentarioC = csvDataNew[i][keys[indexCol11]];
                            } else {
                              comentarioC = "";
                            }
                            if (fecha_apli) {
                              var fecha_apliTmp = csvDataNew[i][keys[indexCol12]];
                              fecha_apliTmp = String(fecha_apliTmp);
                              var f;

                              if (fecha_apliTmp && fecha_apliTmp.length == 5) {
                                f = new Date((fecha_apliTmp - (25567 + 1))*86400*1000);
                                fecha_apliC = ("0" + f.getDate()).slice(-2) + "/" + ("0"+(f.getMonth()+1)).slice(-2) + "/" + f.getFullYear();;
                              } else {
                                fecha_apliC = fecha_apliTmp;
                              }
                            } else {
                              fecha_apliC = "";
                            }
                            if (fecha_ope) {
                              var fecha_opeTmp = csvDataNew[i][keys[indexCol13]];
                              fecha_opeTmp = String(fecha_opeTmp);
                              var f;

                              if (fecha_opeTmp && fecha_opeTmp.length == 5) {
                                f = new Date((fecha_opeTmp - (25567 + 1))*86400*1000);
                                fecha_opeC =  ("0" + f.getDate()).slice(-2) + "/" + ("0"+(f.getMonth()+1)).slice(-2) + "/" + f.getFullYear();
                              } else {
                                fecha_opeC = fecha_opeTmp;
                              }
                            } else {
                              fecha_opeC = "";
                            }
                            if (refeferencia_sant) {
                              refeferencia_santC = csvDataNew[i][keys[indexCol14]];
                            } else {
                              refeferencia_santC = "";
                            }
                            if (estatus_pago) {
                              estatus_pagoC = csvDataNew[i][keys[indexCol15]];
                            } else {
                              estatus_pagoC = "";
                            }
                            if (motivo_rechazo) {
                              motivo_rechazoC = csvDataNew[i][keys[indexCol16]];
                            } else {
                              motivo_rechazoC = "";
                            }
                            if (id_comprobante) {
                              id_comprobanteC = csvDataNew[i][keys[indexCol17]];
                            } else {
                              id_comprobanteC = "";
                            }
                         
                          }
                            
                           json = {
                            "sociedad": sociedadC,
                            "proveedor": proveedorC,
                            "cuentaCargo": cuenta_cargoC, 
                            "nombreOrd": nombre_ordC,
                            "nombreBeneficiario": nombre_benC,
                            "cuentaAbono": cuenta_abonoC,
                            "producto": productoC,
                            "nombreArchivo": nombre_archivoC,
                            "importe": importeC,
                            "intermediarioOrd": intermediario_ordC,
                            "divisaOrd": divisa_ordC,
                            "documentoSap": doc_sapC,
                            "comentario": comentarioC,
                            "fechaAplicacion": fecha_apliC,
                            "fechaOperacion": fecha_opeC,
                            "referencia": refeferencia_santC,
                            "estatusPago": estatus_pagoC,
                            "motivoRechazo": motivo_rechazoC,
                            "idComprobante": id_comprobanteC
                          }
  
                          jsonArray.push(json)
                        
  
                      }
  
                         me.columns = keys;
                         me.rows = jsonArray;
                         me.btnEnviar = true 
  
                         me.jsonExcel = jsonArray; 
  
  
                  } else {
                    me.columns = [];
                    me.rows = [];
                    me.btnEnviar = false;
                    me.files1.length = 0;
                    me.toasterService.pop('error', '', me.archivoNoValido);  
                  }

                } else {
                  me.columns = [];
                  me.rows = [];
                  me.btnEnviar = false;
                  me.files1.length = 0;
                  me.toasterService.pop('error', '', me.archivoNoValido); 
                }
               

              } else {
                me.columns = [];
                me.rows = [];
                me.btnEnviar = false;
                me.files1.length = 0;
                me.toasterService.pop('error', '', me.archivoNoValido);
              }

            });
          }
         fileReader.readAsBinaryString(me.selectedFile); 
          fileReader.onloadend = function () {
            // console.log('DONE', fileReader.readyState); 
            if (me.btnEnviar) {
              me.enviar(modalDetalle); 
            }
          };
        } else {
          me.columns = [];
          me.rows = [];
          me.btnEnviar = false;
          me.files1.length = 0;
          me.toasterService.pop('error', '', this.archivoNoValido); 
        }
              
      //}
     
  }

 
  enviar(modalDetalle) {
    this.busy = true;
    let obj = this.jsonExcel;

    const formData: FormData = new FormData();  
    formData.append('archivoZip', this.archivoZip),
    formData.append('comprobantes', JSON.stringify(obj))
    
   
    this.myVouchersService.cargarFacturaMasiva(formData).subscribe(
      data => {
        
        if (data.result.status == 'ACEPTADO') {

          if (data.result.message !== "") {
            var texto1 = data.result.message.split('[');
            var texto2 = texto1[1].replace(']', "");
            this.textoRespuesta = texto1[0];
            this.detalleRespuesta = texto2;
          
              this.modalDetalle = this.modalService.open(modalDetalle, { centered: true, keyboard: false, backdrop: 'static'});
              this.modalDetalle.result.then((result) => {
              this.closeResult = `Closed with: ${result}`;
              }, (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              });
          }

          this.columns = [];
          this.rows = [];
          this.btnEnviar = false;
          this.files1.length = 0;
          this.files2.length = 0;
          this.files1 = [];
          this.file1 = "";
          this.files2 = [];
          this.file2 = "";
          
        } else if (data.result.status == 'OK') {

          this.columns = [];
          this.rows = [];
          this.btnEnviar = false;
          this.files1.length = 0;
          this.files2.length = 0;
          this.files1 = [];
          this.file1 = "";
          this.files2 = [];
          this.file2 = "";
          
          this.toasterService.pop('success', '', data.result.message);

        } else {
          
          this.toasterService.pop('error', '', data.result.message);

        }

        this.busy = false;
      },
      err => {
        this.busy = false;

        if (err.status === 401) {
          this.storageService.openLogout();
        } else {
          this.toasterService.pop('error', '', err.error.message);
        }
        
      },
    );

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/my-vouchers/upload-vouchers/upload-vouchers.component.ts